import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SkeletonView from '@@viewCommonComponents/groupProtection/SkeletonView.jsx';

const SouscriptionCompanyGroupProtection = ({ getMiddleText }) => (
  <SkeletonView title={'Contact'} getMiddleText={getMiddleText} />
);

export default withMiddleFeatures(SouscriptionCompanyGroupProtection);
